import { Hotkey } from '@/types/Hotkey.ts';

export const DefaultHotkeys: { [key in Hotkey]: string } = {
    [Hotkey.Up]: 'CmdOrCtrl+Up',
    [Hotkey.Down]: 'CmdOrCtrl+Down',
    [Hotkey.Left]: 'CmdOrCtrl+Left',
    [Hotkey.Right]: 'CmdOrCtrl+Right',
    [Hotkey.ActionX1]: 'CmdOrCtrl+1',
    [Hotkey.ActionX2]: 'CmdOrCtrl+2',
    [Hotkey.ActionX3]: 'CmdOrCtrl+3',
    [Hotkey.ActionX4]: 'CmdOrCtrl+4',
    [Hotkey.ActionX5]: 'CmdOrCtrl+5',
    [Hotkey.ActionY1]: 'CmdOrCtrl+9',
    [Hotkey.MoveAppUp]: 'Alt+Up',
    [Hotkey.MoveAppDown]: 'Alt+Down',
    [Hotkey.MoveAppLeft]: 'Alt+Left',
    [Hotkey.MoveAppRight]: 'Alt+Right',
};

export const BlockedHotkeyCombinations = [
    'CmdOrCtrl+0',
    'CmdOrCtrl+plus',
    'CmdOrCtrl+=',
    'CmdOrCtrl+-',
    'CmdOrCtrl+_',
];
